var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2586 9.46994L16.0786 14.2899C16.4686 14.6799 16.4686 15.3199 16.0786 15.7099C15.8786 15.8999 15.6286 15.9999 15.3686 15.9999C15.1086 15.9999 14.8586 15.8999 14.6586 15.7099L9.83862 10.8899C8.85862 11.5899 7.66862 11.9999 6.36862 11.9999C3.05862 11.9999 0.368622 9.30994 0.368622 5.99994C0.368622 2.68994 3.05862 -6.10352e-05 6.36862 -6.10352e-05C9.67862 -6.10352e-05 12.3686 2.68994 12.3686 5.99994C12.3686 7.29994 11.9586 8.48994 11.2586 9.46994ZM2.36862 5.99994C2.36862 8.20994 4.15862 9.99994 6.36862 9.99994C8.57862 9.99994 10.3686 8.20994 10.3686 5.99994C10.3686 3.78994 8.57862 1.99994 6.36862 1.99994C4.15862 1.99994 2.36862 3.78994 2.36862 5.99994ZM4.36862 4.99992H8.36862C8.91862 4.99992 9.36862 5.44992 9.36862 5.99992C9.36862 6.54992 8.91862 6.99992 8.36862 6.99992H4.36862C3.81862 6.99992 3.36862 6.54992 3.36862 5.99992C3.36862 5.44992 3.81862 4.99992 4.36862 4.99992Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.0950a232eabdd931e66bebac30d7ebf6.svg";
export { ForwardRef as ReactComponent };